// المسار: src/Header.js
import React from 'react';

// استقبلنا دالة جديدة اسمها onNavigate
const Header = ({ cartCount, onOpenCart, onAdminClick, onNavigate }) => {
  return (
    <div style={{
      background: '#0f172a',
      color: '#e2e8f0',
      height: '70px',
      padding: '0 5%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderBottom: '1px solid #1e293b',
      fontFamily: 'Segoe UI, sans-serif',
      position: 'sticky', top: 0, zIndex: 1000,
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.3)'
    }}>
      
      {/* الشعار */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', cursor: 'pointer' }} onClick={() => onNavigate('home')}>
        <div style={{ background: '#f59e0b', color: 'black', width: '40px', height: '40px', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', boxShadow: '0 0 15px rgba(245, 158, 11, 0.4)' }}>
          🔓
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span style={{ fontWeight: 'bold', fontSize: '20px', letterSpacing: '1px', lineHeight: '1', color: 'white' }}>
            CPE<span style={{color:'#f59e0b'}}>Unlocker</span>
          </span>
          <span style={{ fontSize: '10px', color: '#94a3b8', letterSpacing: '2px', textTransform: 'uppercase' }}>
            Fast & Safe Server
          </span>
        </div>
      </div>

      {/* الروابط العلوية (تم تفعيلها الآن) */}
      <div className="nav-links" style={{ display: 'flex', gap: '30px', fontSize: '14px', fontWeight: '500' }}>
        <span onClick={() => onNavigate('home')} style={{ cursor: 'pointer', color: 'white', transition: '0.3s' }}>الرئيسية</span>
        
        {/* زر خدمات IMEI */}
        <span onClick={() => onNavigate('imei')} style={{ cursor: 'pointer', color: '#cbd5e1', transition: '0.3s' }} onMouseOver={e => e.target.style.color='#f59e0b'} onMouseOut={e => e.target.style.color='#cbd5e1'}>
          خدمات IMEI
        </span>
        
        {/* زر السيرفرات */}
        <span onClick={() => onNavigate('server')} style={{ cursor: 'pointer', color: '#cbd5e1', transition: '0.3s' }} onMouseOver={e => e.target.style.color='#f59e0b'} onMouseOut={e => e.target.style.color='#cbd5e1'}>
          سيرفرات
        </span>
        
        <span style={{ cursor: 'pointer', color: '#f59e0b', fontWeight: 'bold' }}>🔥 عروض خاصة</span>
      </div>

      {/* الأزرار الجانبية */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
        <button onClick={onAdminClick} style={{ background: '#334155', color: 'white', border: '1px solid #475569', padding: '8px 18px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: 'bold' }}>
          🔐 Client Area
        </button>

        <div onClick={onOpenCart} style={{ position: 'relative', cursor: 'pointer', background: '#2563eb', width: '40px', height: '40px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '20px', boxShadow: '0 0 10px rgba(37, 99, 235, 0.5)' }}>
          🛒
          {cartCount > 0 && <span style={{ position: 'absolute', top: '-5px', right: '-5px', background: '#ef4444', color: 'white', fontSize: '10px', fontWeight: 'bold', width: '18px', height: '18px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '2px solid #0f172a' }}>{cartCount}</span>}
        </div>
      </div>
      <style>{`@media (max-width: 850px) { .nav-links { display: none !important; } }`}</style>
    </div>
  );
};

export default Header;